import type { Release } from '../releases.ts';

export default {
  version: '0.26.0',
  date: '2026-10-09',
  title: 'Metadata model: a board editor, fields by class, needed fields and inspector fields',
  summary: [
    'The metadata model editor is a board of tabs, sections and fields',
    'Show a field only for some classes, or when another field has a value',
    'Needed fields warn without blocking saving, and mark assets as Incomplete metadata',
    'Choose which fields the Library inspector shows',
    'Fixed: taking off the Required flag counts as a change that can be published',
  ],
  features: [
    'The metadata model editor is a board: each tab is a column (scrolling sideways), sections are cards in their column and fields are rows in their section. Drag fields between sections and sections between tabs; the up and down buttons and Alt+arrow keys still work. A field’s settings open in a drawer on the right',
    'Show a field only for some classes: “Show this field” offers Always, When field is…, When class is… or both (both must hold). A field that is not shown for an asset is not asked for, is not required there and is not searched',
    'Needed fields: a Needed flag next to Required warns without blocking saving. An asset with an empty needed field is marked Incomplete metadata: a pill and a warning on the asset page that lists and outlines the fields, a warning in the Library inspector and an icon on grid cards and table rows. The filter pane has Metadata: Incomplete / Complete, and saved searches keep it',
    'Show in inspector: flag the fields the Library inspector should show; it lists them in the model’s order. With none flagged it shows every field that has a value, as before',
    'After a model is published, the incomplete-metadata marks are recomputed for the whole library in the background',
  ],
  fixes: [
    'Taking the Required flag off a field now counts as a change in the review, so it can be published',
  ],
} satisfies Release;
